module.exports = __webpack_public_path__ + "img/newmodel_unsupervised.7c245eb3.png";